// Side-panel content per card. Key = card id; set the same id as detailsKey on the card.

import type { SupportDetailsContent } from "./SupportDetailsPanel";

export const SUPPORT_DETAILS: Record<string, SupportDetailsContent> = {
  HOPE4U: {
    logo: "Hope4U.svg",
    title: "Hope4U",
    subtitle: "Free help to increase your household income",
    sections: [
      {
        heading: "About Hope4U",
        paragraphs: [
          "Hope4U works to reduce poverty. They help with the money problems you're facing now, and the reasons behind them.",
        ],
      },
      {
        heading: "How they can help",
        checks: [
          "Energy advice to reduce bills and improve energy efficiency and awareness of Low Carbon Technology",
          "Check your income to see if you are entitled to benefits",
          "Sign you up to the PSR to ensure you are kept safe during power cuts",
        ],
      },
      {
        heading: "What happens if you say yes",
        numbered: [
          "We add Hope4U to your share list.",
          "When you share your budget, Hope4U receives a copy.",
          "Hope4U contacts you to talk about the help they can offer.",
        ],
      },
    ],
    footnoteHeading: "About this referral",
    footnote:
      "IE Hub support services are free to you. IE Hub may receive a referral fee from partner organisations if you choose to work with them.",
  },
};
